

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// APPROVALSTAKENOWSECTION
// APPROVALSTAKENOWSECTION


const APPROVALSTAKENOWSECTION= createAsyncThunk(
  "approveStakeNowSection/approveStakeNowSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const approveStakeNowSectionSlice = createSlice({
  name: "approveStakeNowSectionSlice",
  initialState: {
    approveStakeNowSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfapproveStakeNowSection: (state) => {
        state.approveStakeNowSection.loading = false
        state.approveStakeNowSection.error = false
        state.approveStakeNowSection.data = []
        state.approveStakeNowSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(APPROVALSTAKENOWSECTION.fulfilled, (state, action) => {
      state.approveStakeNowSection = {
        ...state.approveStakeNowSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVALSTAKENOWSECTION.pending, (state, action) => {
      state.approveStakeNowSection = {
        ...state.approveStakeNowSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVALSTAKENOWSECTION.rejected, (state, action) => {
      state.approveStakeNowSection = {
        ...state.approveStakeNowSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const approveStakeNowSectionAction = {
    APPROVALSTAKENOWSECTION,
};

export { approveStakeNowSectionAction };
export default approveStakeNowSectionSlice.reducer;
export const {setInitialStateOfapproveStakeNowSection} = approveStakeNowSectionSlice.actions
